export default __webpack_public_path__ + "static/media/water_extraction_s2.d54d7db3.jpg";